export const AutoAlignIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <line x1="13" y1="24" x2="18" y2="24" stroke="black" stroke-width="3" />
    <line x1="30" y1="24" x2="34" y2="24" stroke="black" stroke-width="3" />
    <circle
      cx="8"
      cy="24"
      r="5"
      stroke="black"
      stroke-width="3"
      fill="transparent"
    />
    <circle
      cx="24"
      cy="24"
      r="5"
      stroke="black"
      stroke-width="3"
      fill="transparent"
    />
    <circle
      cx="40"
      cy="24"
      r="5"
      stroke="black"
      stroke-width="3"
      fill="transparent"
    />
  </svg>
);
